import Vue from 'vue'
import _misc from '@/assets/utils/misc.js'
import { httpsCallable } from "@/firebase/functions";

// if (process.env.NODE_ENV == 'development')
//   useFunctionsEmulator('http://localhost:5001');

export default {
  namespaced: true,

  state: {
    products: {},
    productsOrder : [],
    showRemoveAlert : true,
  },

  actions: {
    async createOrder ({ state, rootGetters }, { tableId, taxes }) {
      const companyId = rootGetters.getCompanyID;
      console.log(httpsCallable);
      const orderByDash = httpsCallable('orderByDash');
      await orderByDash({ companyId, tableId, orders: state.productsOrder, taxes : taxes });
    },  
    async editOrder ({ rootGetters }, { tableId, order }) {
      const companyId = rootGetters.getCompanyID;
      const editOrderByDash = httpsCallable('editOrderByDash');
      await editOrderByDash({ companyId, tableId, order });
    },
    setQuantity ({ state, rootGetters, commit }, { val, productKey }) {
      const pIndex = state.productsOrder.findIndex(p => productKey == p.key)
      commit('setQuantity', { val, index: pIndex })
    },
    removeProductOrder ({ state, rootGetters, commit }, { productKey }) {
      console.log('key: ', productKey)
      const pIndex = state.productsOrder.findIndex(p => productKey == p.key)
      console.log("pIndex: ", pIndex)
      commit('removeProductOrder', pIndex)
    }
  },

  mutations : {
    cleanUp(state) {
      state.productsOrder = []
    },
    addProductOrder (state, order) {
      state.productsOrder.push({...order, key : _misc.generateId(21)})
    },
    setQuantity (state, { val, index }) {
      Vue.set(state.productsOrder[index], 'quantity', val)
    },
    setPrint (state, {val, index}) {
      Vue.set(state.productsOrder[index], 'print', val)
    },
    setObs (state, { val, index }) {
      Vue.set(state.productsOrder[index], 'obs', val)
    },
    removeProductOrder (state, index) {
      Vue.delete(state.productsOrder, index)
    },
    setShowRemoveAlert (state, val) {
      state.showRemoveAlert = val
    }
  }
}
